<template>
  <section id="recent-news">
    <div class="container">
      <h2 class="sr-only">News</h2>
      <transition name="fade" mode="out-in">
        <div v-if="newsRecent.items.length" key="ready" class="row">
          <div v-for="item in newsRecent.items" :key="item.id" class="col-12 col-md-4">
            <a :href="item.link" class="category-link" target="_blank" rel="noopener noreferrer">
              <h3 v-html="item.name" class="category-title" />
            </a>

            <div class="posts">
              <CardNews v-for="post in item.posts"
                :key="post.id"
                :id="post.id"
                :post="post" />
            </div>
          </div>
        </div>

        <div v-else key="loading" class="row">
          <div v-for="i in 3" :key="i" class="col-12 col-md-4">
            <div class="pc-cat-title"></div>
            <div class="posts">
              <div v-for="x in 4" :key="x" class="pc-post">
                <div class="pc-post-img"></div>
                <div class="pc-content">
                  <div class="pc-post-title"></div>
                  <div class="pc-post-title"></div>
                  <div class="pc-post-title" :style="{ width: '40%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import bus from '@/plugins/bus';
import CardNews from '@/components/cards/CardNews.vue';

export default {
  name: 'HomeNews',

  components: {
    CardNews,
  },

  data() {
    return {
      isLoading: false,
      cacheTime: 3600,
      limit: 4,
      selected: [
        'product-specification',
        'hardware-overclocking',
        'review-unboxing',
      ],
    };
  },

  computed: {
    newsRecent() {
      return this.$store.state.news.recent;
    },

    params() {
      return `?per_page=${this.limit}&_embed=1`;
    },

    options() {
      return {
        params: this.params,
        categories: this.selected,
      };
    },
  },

  mounted() {
    bus.$on('category-ready', this.init);
  },

  beforeDestroy() {
    bus.$off('category-ready', this.init);
  },

  methods: {
    init() {
      const now = this.$day().unix();
      const { items = [], timestamp = null } = this.newsRecent;
      const isExpired = (now - timestamp) > this.cacheTime;
      if ((timestamp || items.length) && !isExpired) return;
      this.fetch();
    },

    async fetch() {
      try {
        this.isLoading = true;
        await this.$store.dispatch('news/getRecent', this.options);
        this.isLoading = false;
      } catch (err) {
        console.log('Recent news unavailable', err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #recent-news {
    background-color: $grey-fade;

    .category-link {
      text-decoration: none;
      color: #00A8B3;

      .category-title {
        display: block;
        color: #00A8B3;
        margin-bottom: 2rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .pc-cat-title {
      @include placeholder-animation;
      height: 1.5rem;
      width: 75%;
      background-color: #bbb;
      margin-top: 0.75rem;
      margin-bottom: 2rem;
    }

    .pc-post {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: $white;
      margin-bottom: 1rem;

      .pc-post-img {
        @include placeholder-animation;
        height: 6rem;
        width: 6rem;
        background-color: #999;
      }

      .pc-content {
        width: calc(100% - 6rem);
        padding: 0.5rem 1rem;
      }

      .pc-post-title {
        @include placeholder-animation;
        height: 1rem;
        width: 100%;
        margin-bottom: 0.5rem;
      }
    }
  }
</style>
